<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_fees_payment']==1">

    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-4">
            <div class="card"> 
            <div class="card-body p-2">
              <div class=" mb-2 d-flex justify-content-between">
                <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
              </div> 
              <table v-for="item in students" :key="item.id" class="table">
              <tr><td colspan="2"><img :src="getFiles(item.student.student_photo)" height="80"/></td></tr>
              <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.student.first_name }} {{ item.student.last_name }} </b></td></tr>
              <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.student.gender }} </span></td></tr>
              <tr><td>Class </td><td> <span class="text-primary h7">{{ item.class.name }} {{ item.stream.name }} </span></td></tr>
              <tr><td>Age </td><td> <span class="text-primary h7">{{ getAge(item.student.dob) }} yrs </span></td></tr>
              <tr><td>Address </td><td> <span class="text-primary h7">{{ item.student.district}} {{ item.student.address }} </span></td></tr>
              <tr><td>SchoolPay Code </td><td> <span class="text-primary h7">{{ item.student.school_pay_code }} </span></td></tr>
            </table>
            </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card">
              <div class="card-body">

                <div class="row">
                  <div class="col-md-4">
                    <b>FEES PAYABLE : 
                    <span v-if="this.bursarytype=='Full Bursary'">0</span>
                    <span v-else-if="this.bursarytype=='Half Bursary'">
                        {{ Number((this.total)/2) }}
                    </span>
                    <span v-else-if="this.bursarytype=='Custom'">
                        {{ Number(this.bursaryvalue) }}
                    </span>
                    <span v-else-if="this.bursarytype=='Percentage'">
                        {{ Number((this.total)*(this.bursaryvalue/100)) }}
                    </span>
                    <span v-else>
                        {{ Number(this.total) }}
                    </span>
                    </b>
                  </div>
                  <div class="col-md-4"> 
                    <b>FEES PAID : {{ Number(this.amount) }}</b>
                  </div>
                  <div class="col-md-4">
                    <span style="color: black;font-size:14px">
                    <b>FEES BALANCE : 
                    <span v-if="this.bursarytype=='Full Bursary'">0</span>
                    <span v-else-if="this.bursarytype=='Half Bursary'">
                        {{ ((Number((this.total)/2) - Number(this.amount)) - Number(this.exemptions)) - Number(this.balances) }}
                    </span>
                    <span v-else-if="this.bursarytype=='Custom'">
                        {{ ((Number(this.bursaryvalue) - Number(this.amount)) - Number(this.exemptions)) - Number(this.balances) }}
                    </span>
                    <span v-else-if="this.bursarytype=='Percentage'">
                        {{ ((Number((this.total)*(this.bursaryvalue/100)) - Number(this.amount))- Number(this.exemptions)) - Number(this.balances) }}
                    </span>
                    <span v-else>
                        {{ ((Number(this.total) - Number(this.amount))- Number(this.exemptions)) - Number(this.balances) }}
                    </span>
                    </b>
                  </span>
                  </div>
                </div>

                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Receipt No</th><th>Amount</th><th>Date</th><th>Re-Print</th></tr></thead>
                <tbody>
                  <tr v-for="item in feespayments" :key="item.id">
                    <td>{{ item.receipt_id }}</td>
                    <td>{{ commas(item.total) }}</td>
                    <td>{{ item.pay_date }}</td>
                    <!-- <td>{{item.pay_option}}</td> -->
                    <td>
                      <b-button @click="edit(item.id,item.total,item.pay_date,item.pay_option)" type="button" class="btn-sm btn" variant="success" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                      <router-link :to="{ path: '/printreciept', query: { id: item.receipt_id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> </router-link>
                    </td>
                  </tr>
                </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <b-modal id="edit-ledger" centered title="Edit Student Ledger" title-class="font-18" hide-footer>
      <form @submit.prevent="editLedger">
          <input v-model="id" type="hidden">
          <label>Amount paid</label>              
          <b-form-input v-model="total"  type="number"></b-form-input> 
          <label>Pay Date</label> {{ paydate }}
          <b-form-input v-model="paydate" type="date"></b-form-input>
          
            <b>Payment Option</b>                        
            <b-form-select v-model="payoption" :options="paymentoptions" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
        
          <div class="form-group d-flex justify-content-end">
              <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-ledger')" >Close</b-button>
              <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
          </div>
      </form>
  </b-modal>
</div>  
<div v-else>
  <div class="row justify-content-center">
    <div class="col-md-8 col-xl-6">
      <div>
        <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
        <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
      </div>
    </div>
  </div>
</div> 
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { feespaymentMethods, paymentoptionComputed, paymentoptionMethods } from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Student Payments Ledger",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Student Payments Ledger",
      items: [{text: "Dashboard",to: "/",},{text: "Payments Ledger",active: true,},],
      userData: JSON.parse(localStorage.getItem("user")),
      id:'',
      students:[],
      feespayments:[],
      amount:0, total:0, paid:0,
      bursaryvalue:'',paydate:'',payoption:'',
      bursarytype:[],exemptions:0, balances:0,
    };
  },
  created() {
    this.showmember();
    this.showfeepayments();
  },
  computed: {
    ...paymentoptionComputed,
  },
  mounted() {
    this.fetchFeesPayments();
    this.fetchPaymentoptions();
  },
  methods: {
    ...feespaymentMethods,
    ...paymentoptionMethods,
    
    edit(id,total,paydate,payoption){
            this.id =id;
            this.total=total;
            this.paydate=paydate;
            this.payoption=payoption;
            this.$bvModal.show('edit-ledger');
        },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth + 1;
    },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"students/"+name;
      return imagelink;
    },
    async showmember(){
      this.student_id=this.$route.query.student_id;
      let url = `/studentprofile/${this.student_id}`;
      await axios.get(url).then((response) => {
        this.students = response.data.students;
      });
    },
    async showfeepayments(){
      this.student_id=this.$route.query.student_id;
      this.term=this.$route.query.term;
      this.year=this.$route.query.year;
      let url = `/studentpaymentsledger/${this.student_id},${this.term},${this.year}`;
      await axios.get(url).then((response) => {
        this.feespayments = response.data.payments[0].payment;
        this.amount=response.data.payments[0].paid;
        this.total=response.data.payments[0].total;
        this.paid=response.data.payments[0].payment.total;
        this.bursarytype=response.data.payments[0].bursary.bursarytype;
        this.bursaryvalue=response.data.payments[0].bursary.bursaryvalue;
        this.exemptions=response.data.payments[0].exemptions;
        this.balances=response.data.payments[0].balances;
      });
    },
        async editLedger(){
            let formData = new FormData();
            formData.append("id", this.id);
            formData.append("total",this.total);
            formData.append("pay_date",this.paydate);
            formData.append("pay_option",this.payoption);
            let url = "/updateledger";
            await axios.post(url,formData).then((response) => {
                if(response.status == 200){
                    this.fetchFeesPayments();
                    this.$bvModal.hide('edit-ledger');
                    this.total="";
                    this.paydate="";
                    this.payoption="";
                    this.$swal({title: 'Successfully updated', text:response.data.message, icon:'success'});
                }
            });
        },
  },
};
</script>